import { render, staticRenderFns } from "./top-search.vue?vue&type=template&id=5f9ac928"
import script from "./top-search.vue?vue&type=script&lang=js"
export * from "./top-search.vue?vue&type=script&lang=js"
import style0 from "./top-search.vue?vue&type=style&index=0&id=5f9ac928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports